module.exports = __webpack_public_path__ + "static/media/icon_hide.067fb676.svg";